import React from 'react'
import { formatCurrencyAutoLocale } from '@/utils/tools'
import { describeBudgetMove } from '@/utils/budget-move'

interface BudgetMove {
    donorName: string
    donorBudget: number
    donorBudgetAfter: number
    movedBudget: number
    totalBudget: number | null
}

interface BudgetMoveSummaryProps {
    move: BudgetMove
    newBudgetTotal: number
    currency?: string
}

/**
 * The budget move of AI audiences added to an existing campaign, next to the budgets of the new audiences: they
 * must add up to the moved amount, so the campaign's total daily budget stays the same.
 */
const BudgetMoveSummary: React.FC<BudgetMoveSummaryProps> = ({ move, newBudgetTotal, currency }) => {
    const format = (minorUnits: number) => formatCurrencyAutoLocale({ amount: minorUnits / 100, currency })
    const matches = newBudgetTotal === move.movedBudget

    return (
        <div
            className="tw:text-sm tw:max-w-[222px] tw:pt-8 tw:flex tw:flex-col tw:gap-2"
            data-testid="budget-move-summary"
        >
            {describeBudgetMove(move, format).map((line) => (
                <span key={line}>{line}</span>
            ))}
            <span className={matches ? undefined : 'tw:text-yellow-300'} role={matches ? undefined : 'status'}>
                {matches
                    ? `The new audiences get ${format(newBudgetTotal)} a day in total.`
                    : `The new audiences get ${format(newBudgetTotal)} a day in total. Change their budgets so they add up to ${format(move.movedBudget)}.`}
            </span>
        </div>
    )
}

export default BudgetMoveSummary
